import React from 'react';
import { BrowserRouter as Router, Routes, Route, } from "react-router-dom"
import ReactDOM from 'react-dom/client';
import "./globals.css";
import './index.css';

import App from './App';
import Signin from './Signin'
import Signout from './Signout'
import Loading from './Loading'
import Blank from './Blank'
import Chrome from './Chrome'
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
/*
const agent = navigator.userAgent.toLowerCase()
if(agent.indexOf('chrome')===-1){ 
  root.render(
    <Router>
      <Routes>
        <Route path="/" element={<Loading/>} />
        <Route path="/index" element={<Chrome/>} />
      </Routes>
    </Router>
  )
}else{*/
  root.render(
    <Router>
      <Routes>
        <Route path="/" element={<Loading/>} />
        <Route path="/index" element={<App/>} />
        <Route path="/signin" element={<Signin/>} />
        <Route path="/signout" element={<Signout/>} />
        {/*<Route path="/blank" element={<Blank/>} >*/}
      </Routes>
    </Router>
  ) 
/*}*/



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
